import {BaseModule} from "./BaseModule";
import {BaseEditor, formGroup} from "../BaseEditor";
import {getDocumentName, UiDms} from "./UiDms";
import {UiDmsDocumentEditor} from "./UiDmsDocumentEditor";
import {BaseFilter} from "./BaseFilter";
import {ColumnInfo, UiTableCell} from "../components/UiTable";
import {MuWidget} from "mu-widget/lib/MuWidget";
import {UiBuSubjects} from "./UiBuSubjects";
import {UiTomSelect} from "../components/UiTomSelect";
import {formatDate, formatDateTime, formatNumber} from "../Utils";
import {UiDmsAttaches} from "./UiDmsAttaches";
import {DmsDocument} from "./Types";
import {UiDmsHistory} from "./UiDmsHistory";
import {TreeSelector} from "../TreeSelector";
import {UiInlineTreeSelector} from "../components/UiInlineTreeSelector";
import {SlashTree, SlashTreeNode} from "../SlashTree";

export class UiDmsDocuments extends BaseModule {

	beforeIndex() {
		super.beforeIndex();
		this.filter.field = "id";
		this.muAppendContent(`
			<h2 mu-id="label">Seznam dokumentů</h2>
			<div mu-id="typeFilter" mu-widget="UiInlineTreeSelector"></div>
			<div class="toolbar">
				<span class="btn btn-link icon-before-add" mu-id="rCreateItem">Přidat dokument</span>
				<span class="btn btn-link icon-before-reload" mu-id="bReload">Obnovit</span>
				<span class="btn btn-link icon-before-filter" mu-id="bFilter">Celý filtr <span mu-id="filterCount" class="badge"></span></span>
				<span class="btn btn-link icon-before-erase" mu-id="bFilterErase">Zrušit filtr</span>
				<span class="btn btn-link icon-before-document-sheet" mu-id="bExport">Export</span>
				<input type="search" class="form-control flex-grow-1" mu-id="cFulltext" mu-keybind="Enter:bFulltextSearch" />
				<!-- <span class="btn icon-erase" mu-id="bFulltextErase"></span> -->
				<span class="btn btn-link icon-before-search" mu-id="bFulltextSearch">Vyhledat</span>
			</div>
			<table mu-id="list" mu-widget="UiTable" class="table table-hover table-sticky-header">
				<tr mu-id="templates">
					<td mu-template="actions" mu-widget="UiDocumentActionCell">
					</td>
					<td mu-template="shared:documentLinkCell" mu-widget="UiDocumentLinkCell">
					</td>
					<td mu-template="noteShorter" mu-widget="UiNoteShorter"></td>
				</tr>
			</table>
			
			<div mu-id="pager" mu-widget="Pager"></div>
		`)
	}

	afterIndex() {
		super.afterIndex();
		const formatCellDate = (value: any, columnInf: ColumnInfo, cell: MuWidget) => value
			? formatDate("d.m.Y", value)
			: '';

		this.muNamedWidget.list.columns = [
			// new ColumnInfo({field: "id", name: "ID", filterable: false}),
			new ColumnInfo({field: "evidenceUid", name: "Naše Evč", cellCssClass: "whitespace-nowrap"}),
			new ColumnInfo({field: "partnerEvidenceUid", name: "Orig. Č", cellCssClass: "whitespace-nowrap"}),
			new ColumnInfo({field: "dmsDocumentTypeId", name: "Typ", template: "shared:tdLink", widgetParams: { showCode: false }}),
			new ColumnInfo({field: "dmsDocumentClassId", name: "Druh", template: "shared:documentLinkCell"}),
			new ColumnInfo({field: "name", name: "Název"}),
			// new ColumnInfo({field: "securityLevel", name: "Stupeň utajení dokumentu", transformContent: v => this.muParent.securityLevels.find(i => i.id == v).title }),
			new ColumnInfo({field: "buSubjectId", name: "Náš subjekt", template: "shared:documentLinkCell"}),
			new ColumnInfo({field: "partnerBuSubjectId", name: "Druhý subjekt", template: "shared:documentLinkCell"}),
			new ColumnInfo({field: "date", name: "Datum", transformContent: formatCellDate}),
			new ColumnInfo({field: "dateFrom", name: "Datum platnosti od", transformContent: formatCellDate}),
			new ColumnInfo({field: "dateTo", name: "Datum platnosti do", transformContent: formatCellDate}),
			// new ColumnInfo({field: "dateProlong", name: "Datum prodloužení", transformContent: formatCellDate}),
			// new ColumnInfo({field: "dateProlongChangeTerm", name: "Termín změny", transformContent: formatCellDate}),
			new ColumnInfo({field: "orgProjectId", name: "Projekt", template: "shared:documentLinkCell"}),
			new ColumnInfo({field: "orgDivisionId", name: "Středisko", template: "shared:documentLinkCell"}),
			new ColumnInfo({field: "responsibleId", name: "Odpovědná osoba", template: "shared:documentLinkCell"}),
			// new ColumnInfo({field: "parentId", name: "Nadřazený dokument", template: "shared:documentLinkCell"}),
			// new ColumnInfo({field: "amount", name: "Částka", template: "shared:tdAmountCurrency", filterable: false}),
			new ColumnInfo({field: "amount", name: "Částka",
				transformContent: (value, columnInf, cell, ev) => ev.isInteractive ? formatNumber(value, 2) : value,
				filterable: false}
			),
			new ColumnInfo({field: "currencyId", name: "Měna", template: "shared:documentLinkCell"}),
			new ColumnInfo({field: "stateId", name: "Stav", template: "shared:documentLinkCell", widgetParams: { showCode: false }}),
			// new ColumnInfo({field: "cancelNote", name: "Poznámka ke stornu", template: "ancestor:noteShorter" }),
			new ColumnInfo({field: "id", name: "-", template: "ancestor:actions", orderable: true, filterable: false, interactiveOnly: true}),
		];
		setTimeout(async() => {
			UiDms.instance.cpDmsDocumentClass.fetch();
			const types = (await UiDms.instance.cpDmsDocumentType.fetch()).filter(t => !t.mustHaveParent);
			(this.muNamedWidget.typeFilter as unknown as UiInlineTreeSelector).bind(SlashTree.parse(types, 'name', ' - '));
		}, 10);
	}

	typeFilter_select(ev, item: SlashTreeNode) {
		const newDTFilter = SlashTree.getItemsRecursive(item).filter(it => it.data.id).map(it => it.data?.id);
		const newDTFilterS = newDTFilter.join(',');
		if (!this.filter.dmsDocumentTypeId || this.filter.dmsDocumentTypeId.join(',') != newDTFilterS) {
			this.filter.dmsDocumentTypeId = newDTFilter;
			this.loadList();
		}
	}

	protected openEditor(id: number): BaseEditor {
		/* const editor = UiDms.instance.openInModal("UiDmsDocumentEditor", id
			? "Upravit dokument"
			: "Vytvořit dokument"
		) as unknown as BaseEditor;
		if (id) editor.loadItem(id);
		return editor; */
		return this.muParent.openDmsDocumentEditor(id);
	}

	protected openFilter(field: string | null): BaseFilter {
		const filter = UiDms.instance.openInModal(
			"UiDocumentFilter",
			"Nastavit filtr",
			{ muParent: this }
		) as unknown as BaseFilter;
		// filter?.showByField(field);

		return filter;
	}

	async rCreateItem_click() {
		const bse = this.openEditor(null);
		if (this.filter.dmsDocumentTypeId?.length == 1) {
			const dmsDocumentTypeId = parseInt(this.filter.dmsDocumentTypeId[0]);
			const dmsDocumentType = await this.muParent.getDmsDocumentType(dmsDocumentTypeId);
			if (!dmsDocumentType.mustHaveParent) {
				bse.muBindData({ dmsDocumentTypeId: dmsDocumentTypeId });
			}
		}
		bse.muBindData({ date: formatDate('Y-m-d', new Date()) });
		bse?.savedPromise.then(() => this.loadList());
	}

	protected getListData(forExport: boolean): Promise<any> {
		return UiDms.instance.cl.allDocuments(
			{ ...this.filter, fulltext: this.ui.cFulltext.value },
			this.orderBy,
			forExport ? 0 : this.muNamedWidget.pager.currentItemFrom,
			forExport ? null : this.muNamedWidget.pager.itemPerPage,
		);
	}

	showAttaches(dmsDocument: DmsDocument) {
		// const atts = UiDms.instance.openInModal<UiDmsAttaches>("UiDmsAttaches", "Přílohy k dokumentu " + getDocumentName(dmsDocument));
		// atts.showForDmsDocument(dmsDocument);
		UiDms.instance.openAttaches(dmsDocument);
	}

	showHistory(dmsDocument: DmsDocument) {
		const atts = UiDms.instance.openInModal<UiDmsHistory>("UiDmsHistory", "...");
		atts.loadForDocument(dmsDocument);
	}
}

export class UiDocumentFilter extends BaseFilter
{
	beforeIndex() {
		super.beforeIndex();
		this.muAppendContent(
			'<div mu-id="searchFields">'
			+ formGroup('dmsDocumentTypeId', 'Typ',
				`<div mu-widget="UiTomSelect" mu-id="dmsDocumentType" mu-bind="dmsDocumentTypeId"></div>`,
				true
			)
			+ formGroup('stateId', 'Stav',
				`<div mu-widget="UiTomSelect" mu-id="state" mu-bind="stateId"></div>`,
				true
			)
			/* + formGroup('securityLevel', 'Stupeň utajení dokumentu',
				`<div mu-widget="UiTomSelect" mu-id="securityLevel" mu-bind="securityLevel"></div>`,
				true
			) */
			+ formGroup('responsibleId', 'Odpovědná osoba',
				`<div mu-widget="UiAccountSelector" mu-id="responsibleId" mu-bind="responsibleId"></div>`,
				true
			)
			+ formGroup('orgDivisionId', 'Středisko',
				`<div mu-widget="TreeSelector" mu-id="orgDivisionId" mu-bind="orgDivisionId" mu-params='{"inModal":true,"multiple":true,"useModalClass":false}'></div>`,
				true
			)
			+ formGroup('dmsDocumentClassId', 'Druh',
				`<div mu-widget="UiTomSelect" mu-id="dmsDocumentClass" mu-bind="dmsDocumentClassId"></div>`,
				true
			)
			+ formGroup('orgProjectId', 'Projekt',
				`<div mu-widget="UiOrgProjectSelector" mu-id="orgProjectId" mu-bind="orgProjectId" mu-params='{"multiple":true}'></div>`,
				true
			)
			+ formGroup('evidenceUid', 'Naše Evč',
				`<input type="search" class="form-control" mu-bind="evidenceUid" />`,
				true
			)
			+ formGroup('name', 'Název',
				`<input type="search" class="form-control" mu-bind="name" />`,
				true
			)
			+ formGroup('buSubjectId', 'Náš Subjekt',
				`<div mu-widget="UiTomSelect" mu-id="buSubjectId" mu-bind="buSubjectId" mu-params='{"multiple":true}'></div>`,
				true
			)
			+ formGroup('partnerEvidenceUid', 'Orig. Č',
				`<input type="search" class="form-control" mu-bind="partnerEvidenceUid" />`,
				true
			)
			+ formGroup('partnerBuSubjectId', 'Druhý subjekt',
				`<div mu-widget="UiBuSubjectSelector" mu-id="partnerBuSubject" mu-bind="partnerBuSubjectId" mu-params='{"multiple":true}'></div>`,
				true
			)
			/* + formGroup('responsibleId', 'Odpovědná osoba',
				`<div mu-widget="UiAccountSelector" mu-id="responsibleId" mu-bind="responsibleId" mu-params='{"multiple":true}'></div>`,
				true
			) */
			+ formGroup('date', 'Datum',
				`<div mu-widget="UiDateFilter" mu-id="date" mu-bind="date"></div>`, true
			)
			+ formGroup('dateFrom', 'Datum platnosti od',
				`<div mu-widget="UiDateFilter" mu-id="dateFrom" mu-bind="dateFrom"></div>`, true
			)
			+ formGroup('dateTo', 'Datum platnosti do',
				`<div mu-widget="UiDateFilter" mu-id="dateTo" mu-bind="dateTo"></div>`, true
			)
			/* + formGroup('dateProlong', 'Datum prodloužení',
				`<div mu-widget="UiDateFilter" mu-id="dateProlong" mu-bind="dateProlong"></div>`, true
			)
			+ formGroup('dateProlongChangeTerm', 'Termín změny',
				`<div mu-widget="UiDateFilter" mu-id="dateProlongChangeTerm" mu-bind="dateProlongChangeTerm"></div>`, true
			) */
			+ `</div><div class="buttons">
				<span class="btn btn-primary" mu-id="bFilter">Filtrovat</span>
				<span class="btn btn-warning" mu-id="bClearFilter">Zrušit filtr</span>
			</div>`
		);
	}

	async afterIndex() {
		let c = (this.muNamedWidget.dmsDocumentClass as unknown as UiTomSelect);
		c.multiple = true;
		c.init();
		c.bindItems(await UiDms.instance.cpDmsDocumentClass.fetch());

		c = (this.muNamedWidget.dmsDocumentType as unknown as UiTomSelect);
		c.multiple = true;
		c.init();
		c.bindItems(await UiDms.instance.cpDmsDocumentType.fetch());

		c = (this.muNamedWidget.buSubjectId as unknown as UiTomSelect);
		c.multiple = true;
		c.init();
		c.bindItems((await UiDms.instance.cpMyBuSubjects.fetch()).read);

		c = (this.muNamedWidget.state as unknown as UiTomSelect);
		c.multiple = true;
		c.init();
		c.bindItems(await UiDms.instance.cpStates.fetch());

		(this.muNamedWidget.orgDivisionId as unknown as TreeSelector).bindTree(
			await UiDms.instance.cpOrgDivision.fetch()
		);

		/* const bss = (this.muNamedWidget.buSubjectId as unknown as UiTomSelect);
		bss.multiple = true;
		bss.init();
		bss.bindItems(await UiDms.instance.cpMyBuSubjects.fetch()); */

		super.afterIndex();
	}
}

export class UiDocumentActionCell extends UiTableCell
{
	beforeIndex() {
		super.beforeIndex();
		this.muAppendContent(`<span mu-id="bEdit" class="whitespace-nowrap a icon-before-edit">Upravit</span>
			<span mu-id="bAttaches" class="whitespace-nowrap a icon-before-document-dir">Přílohy</span>
			<span mu-id="bHistory" class="whitespace-nowrap a icon-before-detail">Historie</span>
			<span mu-id="bSubdocument" mu-template="subdocumentItem" mu-widget="." class="whitespace-nowrap">
				<span mu-id="bAddSubdocument" title="Přidat" class="a icon-before-add"></span>
				<span mu-id="count" title="Zobrazit" class="badge cursor-pointer"></span>
			</span>
		`);
	}

	// @ts-ignore
	private id: number;
	// @ts-ignore
	private dmsDocument: DmsDocument;
	async render(value: any, row: DmsDocument) {
		this.id = value;
		this.dmsDocument = row;
		for(const subTypeCode of row.dmsDocumentTypeId.opts.subDocumentTypes || []) {
			const dmsDocumentType = await UiDms.instance.getDmsDocumentType(subTypeCode);
			this.muWidgetFromTemplate('subdocumentItem', this.container, {
				bAddSubdocument_click: () => UiDms.instance.openDmsDocumentEditor(null, {
					dmsDocumentTypeId: dmsDocumentType.id,
					stateOpts: dmsDocumentType.default.stateOpts,
					parentId: row,
					orgProjectId: row.orgProjectId,
					responsibleId: row.responsibleId,
					orgDivisionId: row.orgDivisionId.id,
					currencyId: row.currencyId,
					buSubjectId: row.buSubjectId,
					partnerBuSubjectId: row.partnerBuSubjectId,
				}),
				count_click: () => UiDms.instance.openDocumentsPreview("Parent", row.id, row),
				afterIndex() {
					(this as MuWidget).ui.bAddSubdocument.innerText = dmsDocumentType.name;
					(this as MuWidget).ui.count.innerText = row.subDocumentCounts[dmsDocumentType.id] || "";
				}
			});
		}
	}

	bEdit_click() {
		const module = this.muParent.muParent.muParent as BaseModule;
		module.loadItem(this.id);
	}

	bAttaches_click() {
		const module = this.muParent.muParent.muParent as UiDmsDocuments;
		module.showAttaches(this.dmsDocument);
	}

	bHistory_click() {
		const module = this.muParent.muParent.muParent as UiDmsDocuments;
		module.showHistory(this.dmsDocument);
	}

	bAddSubdocument_click() {

	}
}

export class UiDocumentLinkCell extends UiTableCell
{
	public labelField = "name";
	private value: any;
	public showCode: boolean = true;

	beforeIndex() {
		super.beforeIndex();
		this.muAppendContent(`<div mu-id="link"><strong mu-id="code"></strong><span mu-id="space"></span><span mu-id="name"></span></div>`)
	}

	link_click() {
		// alert(this.value.id);
	}

	render(value: any) {
		if (true) this.ui.name.innerText = value ? (value[this.labelField] ?? "") : "";
		if (value && value.code && this.showCode) this.ui.code.innerText = value ? value.code + " " : "";
		if (value && value.code && this.showCode && value[this.labelField]) {
			this.ui.space.innerHTML = " &nbsp;";
		}
		this.value = value;
	}
}

export class UiNoteShorter extends UiTableCell
{
	public shortLen: number = 50;

	beforeIndex() {
		this.container.classList.add('note-shorter')
		this.muAppendContent(`<span mu-id="short" class="note-shorter--short"></span><div mu-id="full" class="note-shorter--full"></div>`)
	}

	render(value: any, row: any) {
		this.ui.short.innerText = value?.substr(0, this.shortLen) ?? "";
		this.ui.full.innerText = value ?? "";
	}
}